export enum CASE_GEN_INFORMATION {
  CONTRACT_INFO = 4,
  COMMERCIAL_INFO = 5,
  SIGN_UP_PROCESS_INFO = 23,
}
export type CaseGenInformationType =
  | CASE_GEN_INFORMATION.CONTRACT_INFO
  | CASE_GEN_INFORMATION.COMMERCIAL_INFO
  | CASE_GEN_INFORMATION.SIGN_UP_PROCESS_INFO;

export enum CASE_HIRING {
  ONB_INFO = 36,
  OCR_ISSUE = 37,
  ACCOUNT_ACTIVATION_ISSUE = 49,
  FIRST_TRANSFER_ISSUE = 38,
  FIRST_PASSWORD_ISSUE = 45,
}
export type CaseHiringType =
  | CASE_HIRING.OCR_ISSUE
  | CASE_HIRING.ACCOUNT_ACTIVATION_ISSUE
  | CASE_HIRING.FIRST_TRANSFER_ISSUE
  | CASE_HIRING.FIRST_PASSWORD_ISSUE;

export enum CASE_CONTRACTUAL_MODIF {
  NAME_AND_SURNAME = 13,
  CONTACT_DETAILS_PHONE_MAIL = 14,
  LABOR_DATA = 15,
  ADDRESS_CHANGES = 17,
  PRIVACY_POLICY_OR_CONSENTS = 18,
  BANK_ACCOUNT_CHANGES = 19,
}

export type CaseContractualModifType =
  | CASE_CONTRACTUAL_MODIF.NAME_AND_SURNAME
  | CASE_CONTRACTUAL_MODIF.CONTACT_DETAILS_PHONE_MAIL
  | CASE_CONTRACTUAL_MODIF.LABOR_DATA
  | CASE_CONTRACTUAL_MODIF.ADDRESS_CHANGES
  | CASE_CONTRACTUAL_MODIF.PRIVACY_POLICY_OR_CONSENTS
  | CASE_CONTRACTUAL_MODIF.BANK_ACCOUNT_CHANGES;

export enum CASE_DOCUMENTS {
  PROVIDE_DOCUMENTS = 20,
  REQUEST_CONTRACTUAL_DOCUMENTS = 22,
}
export type CaseDocuments =
  | CASE_DOCUMENTS.PROVIDE_DOCUMENTS
  | CASE_DOCUMENTS.REQUEST_CONTRACTUAL_DOCUMENTS;

export enum CASE_CLAIMS {
  DOUBTS_SUGGESTIONS_IMPROVEMENTS = 23,
  COMPLAINTS = 24,
}
export type caseClaimsType = CASE_CLAIMS.COMPLAINTS;

export enum CASE_CUSTOMER_AREA {
  ACCESS_OPERATIONAL_INCIDENTS = 46,
  PASSWORD = 26,
  TRANSFER_MOVEMENT_ERROR = 47,
  ACCOUNT_ACTIVATION = 28,
  NOT_RECEIVING_EMAIL = 29,
  HOW_TO_TRANSFER_TAX = 30,
  UNLOCK_ACCOUNT = 31,
  REQUEST_DOCS = 48,
}

export type CaseCustomerAreaType =
  | CASE_CUSTOMER_AREA.ACCESS_OPERATIONAL_INCIDENTS
  | CASE_CUSTOMER_AREA.PASSWORD
  | CASE_CUSTOMER_AREA.TRANSFER_MOVEMENT_ERROR
  | CASE_CUSTOMER_AREA.ACCOUNT_ACTIVATION
  | CASE_CUSTOMER_AREA.NOT_RECEIVING_EMAIL
  | CASE_CUSTOMER_AREA.HOW_TO_TRANSFER_TAX
  | CASE_CUSTOMER_AREA.UNLOCK_ACCOUNT;

export enum CASE_CANCELLATIONS {
  NO_AUTOMATIC_RENEWAL = 44,
  TOTAL_CANCELLATION_OF_THE_TERM_DEPOSIT = 34,
  CANCELLATION_DEMAND_DEPOSIT = 35,
  
}
export type CaseCancellationsType =
  | CASE_CANCELLATIONS.NO_AUTOMATIC_RENEWAL
  | CASE_CANCELLATIONS.TOTAL_CANCELLATION_OF_THE_TERM_DEPOSIT
  | CASE_CANCELLATIONS.CANCELLATION_DEMAND_DEPOSIT;
